import { createTransitionStyle } from './createTransitionStyle';
import { getCssProperties } from './getCssProperties';
import { Style } from './types';
import { waitForNextPaint } from './waitForNextPaint';
import { applyStyleToElement } from './applyStyleToElement';

export const jumpToStartStyle = (startStyle: Style, element: HTMLElement) => {
  const jumpTransition = createTransitionStyle(getCssProperties(startStyle), '0s');
  applyStyleToElement({ ...startStyle, ...jumpTransition }, element);
  return waitForNextPaint();
};
